import { render, staticRenderFns } from "./Actors.vue?vue&type=template&id=2c89d6ea&scoped=true&"
import script from "./Actors.vue?vue&type=script&lang=js&"
export * from "./Actors.vue?vue&type=script&lang=js&"
import style0 from "./Actors.vue?vue&type=style&index=0&id=2c89d6ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89d6ea",
  null
  
)

export default component.exports